<template>
  <div id="service-filter">
    <div id="related">
      <van-tabs v-model="selectParams.related" :title-active-color="mainColor()" :color="mainColor()">
        <van-tab title="与我相关" name="true"/>
        <van-tab title="全部事项" name="false"/>
      </van-tabs>
    </div>
    <div class="white-bg">
      <div id="types" class="filter-item-box" v-if="serviceHallCategoryModel() || serviceHallListModel()">
        <div class="title">事项类型</div>
        <div class="tags">
          <div class="tag"
               v-for="(item, index)  in serviceTypes"
               :key="'type-'+index"
               @click="selectTypes(item.id)"
               :class="selectParams.type===item.id?'current':''">
            {{ item.typeName }}
          </div>
        </div>
      </div>
      <div id="objs" class="filter-item-box">
        <div class="title">服务对象</div>
        <div class="tags">
          <div class="tag"
               v-for="(item, index) in serviceObjects"
               :key="'obj-'+index"
               @click="selectObjs(item.id)"
               :class="selectParams.target===item.id?'current':''">{{ item.objectName }}
          </div>
        </div>
      </div>
      <div id="ways" class="filter-item-box">
        <div class="title">办理途径</div>
        <div class="tags">
          <div class="tag"
               v-for="(item, index) in serviceWays"
               :key="'way-'+index" @click="selectWays(item.id)"
               :class="selectParams.handleWay===item.id?'current':''">{{ item.transactWayName }}
          </div>
        </div>
      </div>
      <div id="depts" class="filter-item-box" v-if="!serviceHallCategoryModel() || serviceHallListModel()">
        <div class="title">所属部门</div>
        <div class="tags">
          <div class="tag"
               v-for="(item, index) in serviceDepts"
               :key="'dept-'+index"
               @click="selectDepts(item.deptId)"
               :class="selectParams.publisher===item.deptId?'current':''">{{ item.deptName }}
          </div>
        </div>
      </div>
      <div class="btn-control">
        <button class="btn-reset" @click="reset">取消</button>
        <button class="btn-confirm" @click="confirm">确定</button>
      </div>
    </div>
  </div>
</template>

<script>
import {Tabs, Tab} from 'vant'
import {getThemeParams} from "@/utils/theme";

export default {
  name: "serviceFilter",
  components: {
    'van-tabs': Tabs,
    'van-tab': Tab
  },
  data() {
    return {
      selectParams: {
        target: undefined,
        publisher: undefined,
        handleWay: undefined,
        type: undefined,
        related: "false",
        keyword:undefined
      },
      serviceObjects: this.$store.state.serviceObjects,
      serviceWays: this.$store.state.serviceWays,
      serviceTypes: this.$store.state.serviceTypes,
      serviceDepts: this.$store.state.serviceDepts,
    }
  },
  beforeCreate() {
    this.$store.commit('updateGlobalBg',"#FFFFFF");
  },
  created() {
    if (this.serviceObjects.length <= 0) {
      this.$router.push('/homeTab/serviceHall');
    }
    this.$nextTick(() => {
      let params = this.$store.state.serviceParams;
      this.selectParams.target = params.target;
      this.selectParams.publisher = params.publisher;
      this.selectParams.handleWay = params.handleWay;
      this.selectParams.type = params.type;
      this.selectParams.related = params.related;
      this.selectParams.keyword = params.keyword;
    })
  },
  beforeDestroy() {
    this.$store.commit('updateGlobalBg',"#F7F7F7");
  },
  methods: {
    selectTypes(e) {
      this.selectParams.type = e === 'all' || e === this.selectParams.type ? undefined : e;
    },
    selectObjs(e) {
      this.selectParams.target = e === 'all' || e === this.selectParams.target ? undefined : e;
    },
    selectWays(e) {
      this.selectParams.handleWay = e === 'all' || e === this.selectParams.handleWay ? undefined : e;
    },
    selectDepts(e) {
      this.selectParams.publisher = e === 'all' || e === this.selectParams.publisher ? undefined : e;
    },
    reset() {
      this.$router.go(-1)
    },
    confirm() {
      this.$store.commit("updateServiceParams", this.selectParams);
      if (this.selectParams.publisher) {
        this.$router.push({
          path: '/homeTab/serviceHall',
          query: {deptId: this.selectParams.publisher}
        });
      } else {
        this.$router.push('/homeTab/serviceHall');
      }
    },
    serviceHallCategoryModel(){
      return getThemeParams('hall_default_category') === "0";//0为部门 1为事项
    },
    serviceHallListModel(){
      return getThemeParams('hallListModel') === "0";//0为列表模式 1为名片模式
    },
    mainColor() {
      if (getThemeParams('main_color')){
        return getThemeParams('main_color');
      } else {
        return '#003c88'
      }
    },
    getThemeParams
  }

}
</script>

<style scoped lang="scss">
@import "~@/assets/css/theme/theme.scss";
#service-filter{
  height:100%;
}
#related{
  padding-bottom: 12px;
  background-color: #f7f7f7;
}
.white-bg {
  padding-bottom: 52px;
  margin-top: 12px;
  background: #ffffff;
}

.filter-item-box {
  margin-top: 20px;
  padding:0 15px;
  &:last-child{
    padding-bottom: 12px;
  }
}

.title {
  line-height: 24px;
  color: #333;
  @extend .font16;
}

.tags {
  .tag {
    display: inline-flex;
    //height: 32px;  2022-02-15 bug#3432 过长溢出
    padding: 0 15px;
    margin-right: 10px;
    margin-bottom: 5px;
    margin-top: 5px;
    border-radius: 16px;
    color: #999;
    line-height: 32px;
    background-color: #F7F7F7;
    justify-content:space-around;

    @extend .font14;
    &.current {
      background-color: var(--main-color);
      color: #ffffff;
    }
  }
}

.btn-control {
  width:100%;
  position:fixed;
  bottom:0;
  button {
    width:50%;
    height:40px;
    color: #fff;
    border:none;
    @extend .font14;
    &.btn-reset{
      background-color: #E6E6E6;
      color:#666666;
    }
    &.btn-confirm{
      background-color: var(--main-color);
    }
  }
}

</style>
